import { useRouter } from 'next/router';
import { createRecruitmentSearchInput } from 'client/hooks/recruitment/RecruitmentList/createRecruitmentSearchInput';

export const useSearchQueryParams = (currentDate: Date) => {
  const router = useRouter();
  return createRecruitmentSearchInput(router.query, currentDate);
};
